"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Icon, Typography } from "@/shared/ui/atoms";
const RankingTitle = () => {
  const $ = _c(14);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Typography as="h1" size={22} lineHeight={28} className="font-bold text-gray-800">{t0}</Typography>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon src="/icons/data-trending.svg" alt="" width={28} height={28} className="mt-0.5" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <div className="flex items-start gap-1">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("subtitle");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <Typography size={16} lineHeight={18} className="font-medium text-gray-500">{t4}</Typography>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="flex flex-col gap-2 px-4 pb-4">{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default RankingTitle;